var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", { class: ["button-close", _vm.modify] }, [
    _c("svg", { attrs: { viewBox: "0 0 11 11" } }, [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M5.32262 6.949L1.83262 10.439C1.49311 10.7785\n            0.853809 10.6897 0.404706 10.2406C-0.0443966 9.79146 -0.133238 9.15216 0.206274 8.81265L3.69627\n            5.32265L0.206279 1.83266C-0.133233 1.49315 -0.0443917 0.853849 0.404711 0.404746C0.853814\n            -0.0443571 1.49311 -0.133198 1.83262 0.206314L5.32262 3.69631L8.81265 0.206275C9.15216 -0.133238\n            9.79146 -0.0443967 10.2406 0.404706C10.6897 0.853809 10.7785 1.49311 10.439 1.83262L6.94896\n            5.32265L10.439 8.81269C10.7785 9.1522 10.6897 9.7915 10.2406 10.2406C9.79146 10.6897 9.15216\n            10.7785 8.81265 10.439L5.32262 6.949Z"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }